import * as types from './constants';

export const setCalendarOption = option => ({
  type: types.SET_CALENDAR_OPTION,
  option
});

export const setCalendarList = data => ({
  type: types.SET_CALENDAR_LIST,
  data
});

export const setIsCalendarSelected = status => ({
  type: types.SET_IS_CALENDAR_SELECTED,
  status
});

export const setMapList = data => ({
  type: types.SET_MAP_LIST,
  data
});

export const setCurrentDateCycle = dateType => ({
  type: types.SET_DATE_CYCLE,
  dateType
});

export const setDateCycleText = text => ({
  type: types.SET_DATE_CYCLE_TEXT,
  text
});

export const setMapSelectedDate = date => ({
  type: types.SET_MAP_SELECTED_DATE,
  date
});

export const setIsMapSelected = status => ({
  type: types.SET_IS_MAP_SELECTED,
  status
});

export const setIsFirstSchedulingAccess = () => ({
  type: types.SET_IS_FIRST_SCHEDULING_ACCESS
});

export const setIsBulkUpdateLoading = isLoading => ({
  type: types.SET_IS_BULK_UPDATE_LOADING,
  isLoading
});

export const setIsLoading = isLoading => ({
  type: types.SET_IS_LOADING,
  isLoading
});